/* chanpin guide tanchuang js */
jQuery(function(){
      jQuery(".product-form__option-right_guide").click(function () {
                jQuery('.pc_home_tanchuang').removeClass("hu_none");
                jQuery('.window-cover').show();
          });
      jQuery(".pc_home_tanchuang").click(function () {
        jQuery('.pc_home_tanchuang').addClass("hu_none");
        jQuery('.window-cover').hide();
          });

         var mySwiper = new Swiper('.hu-card-wrapper .swiper-container', {
             allowSlideNext: false,
             allowSlidePrev: false,
              breakpoints: { 
      		 768: {
                allowSlideNext: true,
                allowSlidePrev: true,
      			slidesPerView:1.2,
      			spaceBetween: 15,
              
      			},
        	}
        });
      var pcfeaturedSwipers = new Swiper('.pc-home-featured' , {
          // autoplay: {
    		  //   delay: 5000,
    		  //   disableOnInteraction: false,
          // },
          autoplay: false,
          spaceBetween: 30,
          slidesPerView: 5,
          navigation: {
            nextEl: '.pc-home-featured .swiper-button-next',
            prevEl: '.pc-home-featured .swiper-button-prev',
          }
      });
        var mfeaturedSwipers = new Swiper('.m-home-featured' , {
          // autoplay: {
    		  //   delay: 5000,
    		  //   disableOnInteraction: false,
          // },
          autoplay: false,
          spaceBetween: 10,
          slidesPerView: 2.1,
          navigation: {
            nextEl: '.m-home-featured .swiper-button-next',
            prevEl: '.m-home-featured .swiper-button-prev',
          }
      });

      var height=jQuery(window).height();
		jQuery(window).scroll(function(){
			if (jQuery(window).scrollTop()>height){
				jQuery(".look_up-hu").show();
			}else{
				jQuery(".look_up-hu").hide();
				}
		})
      jQuery('.look_up-hu').on('tap', function () {
          try{
              window.scrollTo({
                  top: 0,
                  left: 0,
                  behavior: 'smooth'
              });
          }catch(e){
              window.scrollTo(0,0);
          }
      
      });
	});

function openPopup(e) {
      	if( e == "paypal" ){
          jQuery('.pc_home_tanchuang-paypal').removeClass("hu_none");
                jQuery('.window-cover').show();
        }
        if( e == "afterpay" ){
            jQuery('.pc_home_tanchuang-afterpay').removeClass("hu_none");
                jQuery('.window-cover').show();
          }
        if( e == "klarna" ){
          jQuery('.pc_home_tanchuang-klarna').removeClass("hu_none");
                jQuery('.window-cover').show();
        }
    }
      jQuery(".pc_home_tanchuang-paypal").click(function () {
        jQuery('.pc_home_tanchuang-paypal').addClass("hu_none");
        jQuery('.window-cover').hide();
      });

      jQuery(".pc_home_tanchuang-afterpay").click(function () {
        jQuery('.pc_home_tanchuang-afterpay').addClass("hu_none");
        jQuery('.window-cover').hide();
      });

      jQuery(".pc_home_tanchuang-klarna").click(function () {
        jQuery('.pc_home_tanchuang-klarna').addClass("hu_none");
        jQuery('.window-cover').hide();
      });